import { connect } from 'react-redux';
import { reduxForm, formValueSelector, change } from 'redux-form';

import Form from '../Components/Form';

import validate from './validate';
import onSubmit from './onSubmit';
import onSubmitFail from './onSubmitFail';

export const FORM_NAME = 'Orders';

const formConfig = {
  form: FORM_NAME,
  validate,
  onSubmit,
  onSubmitFail
}

const selector = formValueSelector(FORM_NAME);

const mapStateToProps = (state) => ({
  hasPartialCoverage: selector(state, 'has_partial_coverage'),
  targetTotal: selector(state, 'target_total')
});

const mapDispatchToProps = (dispatch) => ({
  onChangePartialCoverage: (checked, targetTotal) => {
    if (checked && targetTotal) {
      dispatch(change(FORM_NAME, 'partial_coverage_amount', targetTotal));
    } else if (!checked) {
      dispatch(change(FORM_NAME, 'partial_coverage_amount', null));
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(Form));
